import {
   CurrentHealthcareProviderEwusConfigurationQuery,
   HealthcareProviderEwusConfiguration,
} from '@dreryk/egabinet-ewus-frontend-api';
import {
   CurrentProviderEzwmConfigurationQuery,
   HealthcareProviderEzwmConfiguration,
} from '@dreryk/egabinet-ezwm-frontend-api';
import {
   CurrentHealthcareProviderNfzConfigurationQuery,
   HealthcareProviderNfzConfiguration,
} from '@dreryk/egabinet-nfz-configuration-frontend-api';

import { useCqrsFind } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { nfzSettingsTranslationKeys } from '../../../translations';

type NfzSettingsFormLoaderRenderProps = {
   nfzConfiguration: HealthcareProviderNfzConfiguration | null;
   ewusConfiguration: HealthcareProviderEwusConfiguration | null;
   ezwmConfiguration: HealthcareProviderEzwmConfiguration | null;
};

type NfzSettingsFormLoaderProps = {
   readonly children: (renderProps: NfzSettingsFormLoaderRenderProps) => JSX.Element;
};

export const NfzSettingsFormLoader = (props: NfzSettingsFormLoaderProps): JSX.Element => {
   const {
      data: nfzConfiguration,
      loading: nfzConfigurationLoading,
      error: nfzConfigurationError,
   } = useCqrsFind<HealthcareProviderNfzConfiguration>(() => {
      return new CurrentHealthcareProviderNfzConfigurationQuery();
   });

   const {
      data: ewusConfiguration,
      loading: ewusConfigurationLoading,
      error: ewusConfigurationError,
   } = useCqrsFind<HealthcareProviderEwusConfiguration>(() => {
      return new CurrentHealthcareProviderEwusConfigurationQuery();
   });

   const {
      data: ezwmConfiguration,
      loading: ezwmConfigurationLoading,
      error: ezwmConfigurationError,
   } = useCqrsFind<HealthcareProviderEzwmConfiguration>(() => {
      return new CurrentProviderEzwmConfigurationQuery();
   });

   if (nfzConfigurationLoading || ewusConfigurationLoading || ezwmConfigurationLoading) {
      return <LoaderSpinner />;
   }

   if (nfzConfigurationError || ewusConfigurationError || ezwmConfigurationError) {
      return (
         <Message
            testId={'failedToFetchNfzConfiguration'}
            label={nfzSettingsTranslationKeys.failedToFetchNfzConfiguration}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      nfzConfiguration: nfzConfiguration,
      ewusConfiguration: ewusConfiguration,
      ezwmConfiguration: ezwmConfiguration,
   });
};
